import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';
import { Transaction, CategoryItem, ResponsibleItem, DestinationItem } from '../types/budget';
import { TransactionForm } from './TransactionForm';

interface TransactionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTransaction?: Transaction;
  isInverseTransaction?: boolean;
  onSubmit: (transactions: Array<Omit<Transaction, 'id'>>) => void;
  budgetId: number | null;
  categories: CategoryItem[];
  responsibles: ResponsibleItem[];
  destinations: DestinationItem[];
  transactionType?: 'income' | 'expense';
}

export const TransactionDialog: React.FC<TransactionDialogProps> = ({
  isOpen,
  onClose,
  selectedTransaction,
  isInverseTransaction = false,
  onSubmit,
  budgetId,
  categories,
  responsibles,
  destinations,
  transactionType,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-10 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center">
        <div
          className="fixed inset-0 bg-black bg-opacity-30 dark:bg-opacity-50"
          aria-hidden="true"
        />

        <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-8 dark:bg-surface-800">
          <Dialog.Title
            className={`mb-4 text-lg font-medium ${
              selectedTransaction && !isInverseTransaction
                ? 'text-slate-900 dark:text-white'
                : transactionType === 'expense'
                  ? 'text-slate-900 dark:text-white'
                  : 'text-slate-900 dark:text-white'
            }`}
          >
            {selectedTransaction && !isInverseTransaction
              ? t('transaction.edit')
              : transactionType === 'expense'
                ? t('transaction.newExpense')
                : t('transaction.newIncome')}
          </Dialog.Title>

          <TransactionForm
            transaction={selectedTransaction}
            isInverseTransaction={isInverseTransaction}
            onSubmit={onSubmit}
            onCancel={onClose}
            budgetId={budgetId}
            categories={categories}
            responsibles={responsibles}
            destinations={destinations}
            transactionType={transactionType}
          />
        </div>
      </div>
    </Dialog>
  );
};
